<template lang="pug">
.text-muted.m-4(v-if="!users && !failed")
    img.mr-3(
        src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA=="
    )
    | Benutzer werden geladen

.text-danger.m-4(v-else-if="failed")
    | Benutzer konnten nicht geladen werden. Ihnen fehlt eventuell die Berechtigung.

.users(v-else)
    create-user-modal.text-right.mb-4(@created="loadUsers")

    .list-group
        .list-group-item(v-for="user in users")
            .media
                font-awesome-icon.mr-3.mt-2(icon="user-circle", size="2x")
                .media-body
                    strong {{ user.username }}
                    br
                    | {{ roles[user.role] }} - erstellt am {{ formatDate(user.createdAt) }}

            .btn-toolbar
                button.btn.btn-sm.btn-secondary(v-if="user.role === 'user'", @click="changeRole(user, 'moderator')")
                    font-awesome-icon.mr-2(icon="chevron-up")
                    | Zu Meister hochstufen

                button.btn.btn-sm.btn-secondary(v-if="user.role === 'moderator'", @click="changeRole(user, 'user')")
                    font-awesome-icon.mr-2(icon="chevron-down")
                    | Zu Techniker herabstufen

                change-password-modal(:user="user")
                remove-user-modal(:user="user", @removed="loadUsers")
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faUserCircle, faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons'
import { userService } from '@/services'
import { formatDate } from '@/utils/format'

import CreateUserModal from './Modals/CreateUser'
import ChangePasswordModal from './Modals/ChangePassword'
import RemoveUserModal from './Modals/RemoveUser'

library.add(faUserCircle, faChevronUp, faChevronDown)

const roles = {
    administrator: 'Administrator',
    user: 'Techniker',
    moderator: 'Meister',
    owner: 'Inhaber'
}

export default {
    components: {
        CreateUserModal,
        ChangePasswordModal,
        RemoveUserModal
    },
    data () {
        return {
            roles,
            failed: false,
            users: null
        }
    },
    mounted () {
        this.loadUsers()
    },
    methods: {
        formatDate,
        async loadUsers () {
            try {
                this.users = await userService.list()
            } catch (err) {
                this.failed = true
            }
        },
        async changeRole (user, role) {
            try {
                await userService.update(user.id, { role })
                this.$store.dispatch('alert/success', user.username + ' ist jetzt ' + this.roles[role])
                // refresh user list
                this.loadUsers()
            } catch (error) {
                this.$store.dispatch('alert/error', 'Benutzer konnten nicht hochgestuft werden (' + error.message + ')')
            }
        }
    }

}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";

.list-group-item {
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .media {
        margin-bottom: 0.5rem;
    }

    @include media-breakpoint-up(lg) {
        flex-direction: row;
        align-items: center;

        .media {
            margin-bottom: 0;
        }
    }

    .btn-toolbar {
        > div,
        > button {
            margin-left: 1rem;
        }
    }
}
</style>
